<template>
  <svg
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.335 29.67C23.6997 29.67 29.67 23.6997 29.67 16.335C29.67 8.97028 23.6997 3 16.335 3C8.97028 3 3 8.97028 3 16.335C3 23.6997 8.97028 29.67 16.335 29.67ZM26.7067 16.335C26.7067 22.0631 22.0631 26.7067 16.335 26.7067C10.6069 26.7067 5.96333 22.0631 5.96333 16.335C5.96333 10.6069 10.6069 5.96333 16.335 5.96333C22.0631 5.96333 26.7067 10.6069 26.7067 16.335ZM22.24 14.842H19.648L19.288 17.758H21.628V19.72H19.054L18.694 22.6H16.66L17.02 19.72H14.374L14.014 22.6H11.998L12.358 19.72H10V17.758H12.592L12.97 14.842H10.612V12.88H13.204L13.564 10H15.58L15.22 12.88H17.866L18.226 10H20.242L19.882 12.88H22.222L22.24 14.842ZM14.986 14.842L14.608 17.758H17.254L17.632 14.842H14.986Z"
      fill="currentColor"/>
  </svg>
</template>
